import { IComponentOptions } from 'angular';
import template from './quick-start-guide-wizard-view.component.html';

export const QuickStartGuideWizardViewComponent = {
	controller: () => {},
	require: {
		wizardController: '^wizard'
	},
	template
} as IComponentOptions;
